import React, { useState, useEffect } from "react";
import BgSection2V1 from "./images/section2-bg.png";
import BgSection2V2 from "./images/section2-bg-v2.png";

import BeautyIcon from "./images/icons/beauty-icon.png";
import FlagIcon from "./images/icons/flag-korea.png";
import HouseIcon from "./images/icons/house-icon.png";
import LineOA from "./images/icons/line-missykim.png";
import ShopIcon from "./images/icons/shop-icon.png";
import { SiLine } from "react-icons/si";

const Section2 = ({ onAddLineClick }) => {
  const [isMobile, setIsMobile] = useState(false);

  // ฟังชั่นเพื่อตรวจสอบขนาดหน้าจอ
  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)"); // ตรวจสอบขนาดหน้าจอ 768px หรือน้อยกว่า
    setIsMobile(mediaQuery.matches); // ถ้าเป็นมือถือ (ขนาด <= 768px) จะเปลี่ยน state

    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleResize);

    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  // const handleAddLineClick = () => {
  //   window.open("https://lin.ee/djFqNgN", "_blank");
  // };

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-full">
        <img
          src={isMobile ? BgSection2V2 : BgSection2V1} // เปลี่ยน bg ตามขนาดหน้าจอ
          alt="Missy Kim Background"
          className="w-full h-full object-cover"
        />
      </div>

      {/* โลโก้และข้อความแสดงผล */}
      <div
        className={`absolute flex mt-3 sm:right-2 sm:mt-[5%] xl:left-[41%] gap-4 ${
          isMobile ? "right-[6%]" : "right-8"
        }`}
      >
        <div className="mr-0 sm:mr-2 md:mr-8">
          <div className="text-3xl md:text-4xl font-bold text-black">
            ADD LINE <br />
          </div>
          <div className="text-2xl md:text-4xl font-semibold text-black">
            รับส่วนลด 10%
          </div>
        </div>
        <img
          src={LineOA}
          alt="Line OA Logo"
          className="w-20 h-20 md:w-40 md:h-40"
        />
      </div>

      {/* ปุ่ม Add Line */}
      <button
        id="add-line-header"
        onClick={onAddLineClick}
        className="absolute left-[23%] bg-[#06C755] p-2 w-auto h-5 md:h-14 xl:h-16 rounded-lg flex justify-center items-center mt-[20%] shadow-md 
  md:mt-[15%] md:w-40 md:left-[15%] xl:left-[40%] xl:mt-[12%] xl:w-52 2xl:mt-[10%] hover:bg-[#06A755] cursor-pointer gap-2
  px-4 md:px-0"
      >
        <div className="text-white text-base md:text-2xl xl:text-4xl font-semibold mt-2 md:mt-0"
        style={{ pointerEvents: "none" }}
        >
          ADD LINE
        </div>
        <SiLine className="text-white w-4 h-4 md:w-10 md:h-10 xl:w-12 xl:h-12"
        style={{ pointerEvents: "none" }}
        />
      </button>

      {/* โลโก้ธงเกาหลี */}
      <div className="absolute mt-[32%] flex md:mt-[25%]">
        <img
          src={FlagIcon}
          alt="Line OA Logo"
          className="w-8 h-6  md:h-14 md:w-20 xl:h-24 xl:w-32"
        />
      </div>

      {isMobile && (
        <div className="absolute mt-[40%] flex">
          <h1 className="font-bold text-2xl md:text-4xl xl:text-6xl">
            WHO ARE MISSYKIM?
          </h1>
        </div>
      )}

      {/* Content Who are MissyKim */}
      <div className="absolute mt-[40%] flex p-8 gap-2 md:mt-[40%] md:gap-4 lg:mt-[40%] md:items-center">
        <img
          src={HouseIcon}
          alt="House Logo"
          className="w-12 h-12 md:w-14 md:h-14 xl:w-24 xl:h-24"
        />
        <div>
          <h2 className="text-xl md:text-2xl xl:text-4xl font-bold">
            Multi-brand store
          </h2>
          <p className="text-lg md:text-2xl xl:text-4xl">
            ร้านมัลติแบรนด์ ที่รวบรวม Skincare และ Beauty Item จากเกาหลี
          </p>
        </div>
      </div>

      <div className="absolute mt-[62%] flex p-8 gap-2  md:mt-[50%] md:gap-4 lg:mt-[50%] xl:min-w-[910px] md:items-center md:justify-end">
        <div>
          <h2 className="text-xl md:text-2xl xl:text-4xl font-bold text-right">
            Premium Selected
          </h2>
          <p className="text-lg md:text-2xl xl:text-4xl text-right">
            คัดเลือกสกินแคร์แบรนด์เกาหลี ที่คนเกาหลีใช้จริง <br />
            ทั้งแบรนด์ดัง และไม่ดัง
          </p>
        </div>
        <img
          src={ShopIcon}
          alt="Shop Logo"
          className="w-12 h-12 text-right md:w-20 md:h-20 xl:w-24 xl:h-24"
        />
      </div>

      <div className="absolute mt-[84%] flex p-8 gap-2 md:mt-[60%] md:gap-4 md:min-w-[678px] lg:mt-[60%] xl:min-w-[910px] md:items-center">
        <img
          src={BeautyIcon}
          alt="Shop Logo"
          className="w-12 h-12 md:w-20 md:h-20 xl:w-24 xl:h-24"
        />
        <div>
          <h2 className="text-xl md:text-2xl xl:text-4xl font-bold">
            Thai Understanding
          </h2>
          <p className="text-lg md:text-2xl xl:text-4xl">
            คัดสรรสกินแคร์จากเกาหลีที่เหมาะกับสภาพผิวคนไทย
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section2;
